import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import {
  FONT_BODY, WHITE, NavbarSummit, FloatingDock
} from './SummitLandingpage.tsx'

import {
  ServicesHero,
  ServiceCategories,
  WhatWeBuild,
  DeliveryProcess,
  AITechnology,
  IndustrySolutions,
  DeploymentSection,
  ServicesOutcomes,
  ServicesCTA
} from '../components/services/ServicesComponents.tsx'

export default function ServicesPage() {
  // Always scroll to the top of the page on render
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div style={{ background: WHITE, minHeight: '100vh', fontFamily: FONT_BODY, overflowX: 'hidden' }}>
      <Helmet>
        <title>GliedAI Services - AI Solutions and Services</title>

        <meta
          name="description"
          content="Explore GliedAI services and AI-powered solutions designed for modern business needs."
        />

        <link
          rel="canonical"
          href="https://gliedai.com/services"
        />
      </Helmet>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500&family=Space+Mono:wght@400;700&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,300,0,0');

        .material-symbols-outlined {
          font-family: 'Material Symbols Outlined';
          font-weight: 300;
          font-style: normal;
          font-size: 28px;
          line-height: 1;
          letter-spacing: normal;
          text-transform: none;
          display: inline-block;
          white-space: nowrap;
          word-wrap: normal;
          direction: ltr;
          -webkit-font-feature-settings: 'liga';
          -webkit-font-smoothing: antialiased;
          font-feature-settings: 'liga';
        }

        .service-icon {
          font-size: 30px;
          color: #c8e6ff;
          font-weight: 300;
          transition: transform 0.3s ease, color 0.3s ease;
        }

        .service-bullet {
          font-size: 15px;
          color: #38bdf8;
          vertical-align: middle;
        }

        /* Custom scroll behavior override if needed */
        html {
          scroll-behavior: smooth;
        }

        /* Focus outlines */
        input:focus, select:focus, textarea:focus {
          box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);
        }
      `}</style>

      {/* Global Navigation */}
      <NavbarSummit />

      {/* Hero Section */}
      <ServicesHero />

      {/* Core Services Categories */}
      <ServiceCategories />

      {/* Detail Architectural Deliverables */}
      <WhatWeBuild />

      {/* Delivery Process Roadmap */}
      <DeliveryProcess />

      {/* AI Technology & Protocols Stack */}
      <AITechnology />

      {/* Industry-specific AI solutions */}
      <IndustrySolutions />

      {/* Hosting & Compliance Models */}
      <DeploymentSection />

      {/* Quantitative Value Metrics */}
      <ServicesOutcomes />

      {/* Request Blueprint CTA Form */}
      <ServicesCTA />

      {/* Secondary Bottom Navigation Dock */}
      <FloatingDock />

      {/* Brand Footer */}
      <footer
        style={{
          background: '#080b0c',
          borderTop: '1px solid rgba(255, 255, 255, 0.05)',
          padding: '48px 20px',
          textAlign: 'center',
          position: 'relative',
          zIndex: 10,
        }}
      >
        <div
          style={{
            maxWidth: 1280,
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 20,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img
              src="/logo_without_bg.png"
              alt="Gliedai Logo"
              width={26}
              height={26}
              style={{ objectFit: 'contain' }}
            />
            <span
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 22,
                color: '#ffffff',
                letterSpacing: '0.12em',
              }}
            >
              GLIEDAI
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 12,
              color: 'rgba(255, 255, 255, 0.4)',
              letterSpacing: '0.02em',
              maxWidth: 400,
              lineHeight: 1.5,
            }}
          >
            &copy; {new Date().getFullYear()} GLIEDAI. All rights reserved. Engineered for high-throughput, secure cognitive automation.
          </p>
        </div>
      </footer>
    </div>
  )
}
